import { SearchRepository, SearchService } from '@aipb/gulliver/catalog/data-access';
import { SearchItem, SearchTab } from '@aipb/gulliver/catalog/model';
import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, of } from 'rxjs';
import { ResultItemComponent } from '../result-item/result-item.component';

@UntilDestroy()
@Component({
  selector: 'cat-result-tab-item',
  templateUrl: './result-tab-item.component.html',
  styleUrls: ['./result-tab-item.component.scss'],
  standalone: true,
  imports: [CommonModule, ResultItemComponent]
})
export class ResultTabItemComponent implements OnChanges {
  @Input() searchTab: SearchTab;

  searchItem$: Observable<SearchItem> = of(null);

  constructor(private searchService: SearchService, private searchRepository: SearchRepository) {}

  ngOnChanges(): void {
    this.init();
  }

  private init(): void {
    if (!this.searchTab) return;

    this.searchItem$ = this.searchRepository.selectSearch(this.searchTab.id);

    this.searchService.fetchTabSearch(this.searchTab).pipe(untilDestroyed(this)).subscribe();
  }
}
